import { getVehicle, getPartnerType, getKeysMapping } from './storage-data';
import { showError } from './debug-log';

const dataCache = {
  vehicle: null,
  partnerType: null,
  keysMapping: null,
};

export const initializeCache = async () => {
  try {
    // Fetch data and store it in the cache
    if (!dataCache.vehicle) dataCache.vehicle = await getVehicle();
    if (!dataCache.partnerType) dataCache.partnerType = await getPartnerType();
    if (!dataCache.keysMapping) dataCache.keysMapping = await getKeysMapping();
  } catch (error) {
    showError('Failed to initialize data cache:', error);
  }
};

export const getCachedData = (key) => {
  if (!dataCache[key]) {
    console.warn(`Cache miss for key: ${key}`);
  }
  return dataCache[key];
};